export default "__VITE_ASSET__cb7e0fba__"